import { ProvedorCobrancaNome } from "./ProvedorCobrancaNomeEnum";

export class DadosPagamentoModel {
  Nome: string;
  Email: string;
  CpfCnpj: string;
  TelefoneDDD: string;
  Telefone: string;
  EmpresaId: string;
  AgendamentoId: string;
  Placa: string;
  CartaoCreditoTokenId = '';
  PagamentoTipo = '';
  VistoriaValor: string;
  ProvedorCobrancaNome: ProvedorCobrancaNome;
}